<template>
  <div>
    <ul class="grid-files" id="data-files" v-loading="loading">
      <span v-if="haveFolder()" class="d-flex flex-wrap">
        <li class="file" v-for="(folder,index) in folders" v-bind:key="index" @dblclick="openFolder (folder.id,folder.media_type_id)" v-if="folders.length" title="ダブルタップして開きます">
          <div class="file-content mypage__files">
            <div class="mypage__thumbnail">
              <div class="gridFiles-mb">
                <img :src="folder.icon_url" alt="" class="mypage__files__image">
                <span class="folder-total-1" v-if="isFolder(folder.media_type_id)">{{folder.total_files}}</span>
                <div class="mypage__kindFile">
                  <div class="mypage__iconList" v-if="isVideoAndImage(folder.media_type_id)">
                    <img src="@img/icon/icon-image.svg" alt="" v-if="isImage(folder.media_type_id)">
                    <img src="@img/icon/icon-video.svg" alt="" v-if="isVideo(folder.media_type_id)">
                  </div>
                  <div class="mypage__iconList mypage__file-action" v-if="folder.like_action">
                    <i class="icon-i-like"></i>
                  </div>
                </div>
                <div class="mypage__fileFavorite wider-click action-hover">
                  <b-dropdown class="dropdownAction" variant="link"  toggle-class="text-decoration-none" no-caret>
                    <template v-slot:button-content>
                      <i class="icon-i-dot"></i>
                      <!-- <img src="@img/icon/icon-dot.svg" alt=""> -->
                    </template>
                    <b-dropdown-item @click="openFolder(folder.id,folder.media_type_id)">
                      <i class="icon-i-eyes"></i>
                      <span>開く</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="showModalDetail(folder.id,folder.media_type_id)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14.2" height="16.2" viewBox="0 0 14.2 16.2">
                        <path id="Path_10175" data-name="Path 10175" d="M14.344-11.422q-.266-.359-.617-.758t-.742-.8q-.406-.391-.8-.742t-.758-.617a4.129,4.129,0,0,0-.93-.547A1.667,1.667,0,0,0,10-15H2.25a1.2,1.2,0,0,0-.883.367A1.2,1.2,0,0,0,1-13.75V-.25a1.2,1.2,0,0,0,.367.883A1.2,1.2,0,0,0,2.25,1h11.5a1.2,1.2,0,0,0,.883-.367A1.2,1.2,0,0,0,15-.25V-10a1.667,1.667,0,0,0-.109-.492A4.129,4.129,0,0,0,14.344-11.422Zm-2.078-.844q.359.359.648.68t.492.586H11v-2.406q.266.2.586.492T12.266-12.266ZM14-.25a.243.243,0,0,1-.07.18.243.243,0,0,1-.18.07H2.25a.243.243,0,0,1-.18-.07A.243.243,0,0,1,2-.25v-13.5a.243.243,0,0,1,.07-.18A.243.243,0,0,1,2.25-14H10v3.5a.481.481,0,0,0,.148.352A.481.481,0,0,0,10.5-10H14ZM11.5-2h-7a.481.481,0,0,1-.352-.148A.481.481,0,0,1,4-2.5a.481.481,0,0,1,.148-.352A.481.481,0,0,1,4.5-3h7a.481.481,0,0,1,.352.148A.481.481,0,0,1,12-2.5a.481.481,0,0,1-.148.352A.481.481,0,0,1,11.5-2Zm0-2h-7a.481.481,0,0,1-.352-.148A.481.481,0,0,1,4-4.5a.481.481,0,0,1,.148-.352A.481.481,0,0,1,4.5-5h7a.481.481,0,0,1,.352.148A.481.481,0,0,1,12-4.5a.481.481,0,0,1-.148.352A.481.481,0,0,1,11.5-4Zm0-2h-7a.481.481,0,0,1-.352-.148A.481.481,0,0,1,4-6.5a.481.481,0,0,1,.148-.352A.481.481,0,0,1,4.5-7h7a.481.481,0,0,1,.352.148A.481.481,0,0,1,12-6.5a.481.481,0,0,1-.148.352A.481.481,0,0,1,11.5-6Z" transform="translate(-0.9 15.1)" fill="#333" stroke="#313131" stroke-width="0.2"/>
                      </svg>
                      <span class="ml-12">詳細表示</span>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="isNotFileLike(folder.media_type_id,folder.like_action)" @click="likeFile (folder.id, folder.like_action)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18.573" height="16.453" viewBox="0 0 18.573 16.453">
                        <path id="Path_25128" data-name="Path 25128" d="M12.905-12.25a4.506,4.506,0,0,0-2.437.686A4.657,4.657,0,0,0,8.787-9.779,4.657,4.657,0,0,0,7.1-11.564a4.506,4.506,0,0,0-2.437-.686,4.5,4.5,0,0,0-1.811.369,4.758,4.758,0,0,0-1.484,1,4.758,4.758,0,0,0-1,1.484A4.5,4.5,0,0,0,0-7.582,7.4,7.4,0,0,0,1.373-3.249,18.068,18.068,0,0,0,4.393.132a20.246,20.246,0,0,0,3.02,2.205l1.373.789,1.373-.781a19.73,19.73,0,0,0,3.02-2.2A17.95,17.95,0,0,0,16.2-3.24a7.439,7.439,0,0,0,1.373-4.342A4.5,4.5,0,0,0,17.2-9.393a4.758,4.758,0,0,0-1-1.484,4.758,4.758,0,0,0-1.484-1A4.5,4.5,0,0,0,12.905-12.25Z" transform="translate(0.5 12.75)" fill="none" stroke="#333" stroke-width="1"/>
                      </svg>
                      <span class="ml-12">お気に入り</span>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="isFileLike(folder.media_type_id,folder.like_action)" class="icon-favorite" @click="likeFile (folder.id, folder.like_action)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17.573" height="15.377" viewBox="0 0 17.573 15.377">
                        <path id="Path_25128" data-name="Path 25128" d="M12.905-12.25a4.506,4.506,0,0,0-2.437.686A4.657,4.657,0,0,0,8.787-9.779,4.657,4.657,0,0,0,7.1-11.564a4.506,4.506,0,0,0-2.437-.686,4.5,4.5,0,0,0-1.811.369,4.758,4.758,0,0,0-1.484,1,4.758,4.758,0,0,0-1,1.484A4.5,4.5,0,0,0,0-7.582,7.4,7.4,0,0,0,1.373-3.249,18.068,18.068,0,0,0,4.393.132a20.246,20.246,0,0,0,3.02,2.205l1.373.789,1.373-.781a19.73,19.73,0,0,0,3.02-2.2A17.95,17.95,0,0,0,16.2-3.24a7.439,7.439,0,0,0,1.373-4.342A4.5,4.5,0,0,0,17.2-9.393a4.758,4.758,0,0,0-1-1.484,4.758,4.758,0,0,0-1.484-1A4.5,4.5,0,0,0,12.905-12.25Z" transform="translate(0 12.25)" fill="#56C677"/>
                      </svg>
                      <span class="ml-12">お気に入り</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
            <div class="mypage__files__title line-1">{{truncate(folder.name,5,'...')}}</div>
            <div class="mypage__files__datetime">{{dateFormat(folder.updated_time)}}</div>
          </div>
        </li>
      </span>
      <div v-if="isSearch && !loading && !showNoData()" class="text-center">
        <b-link class="btn btn-rounder btn-primary btn-contact w-100 btn-basic my-4 mx-auto" :to="{name: 'employee_file', params: {id: 0}}">ファイル一覧に戻る</b-link>
      </div>
      <div class="d-flex justify-content-center align-items-center no-result" v-if="showNoData()">
        <img src="@img/icon/no-result.svg" class="img-no-result" />
        <div class="no-result-text" v-if="folderIsSearch()">データなし</div>
        <div class="no-result-text" v-else>検索結果がありませんでした。</div>
        <div class="no-result-text back-to-files">
          <b-link :to="{name: 'employee_file', params: {id: 0}}">ファイルに戻る</b-link>
        </div>
      </div>
    </ul>
    <Pagination v-if="totalPages > 1 && !this.loading" :totalPages="totalPages" :pageIndexNo="pageIndex" @changePage="changePage"/>
    <ModalFolderDetail />
    <ModalFileDetail />
    <ModalViewFile/>
  </div>

</template>

<script>
import ModalFolderDetail from '@/views/Employee/FolderManager/FolderDetail'
import ModalFileDetail from '@/views/Employee/FolderManager/FileDetail'
import ModalViewFile from '@/views/Employee/FolderManager/ViewFile'
import { BModal, VBModal } from 'bootstrap-vue'
import {MEDIA_TYPE, ACTION} from '@/utils/constant'
import {mapState} from 'vuex'
import Pagination from '@/components/share/Pagination.vue'
export default {
  name: 'GridFile',
  components: {
    BModal,
    ModalFolderDetail,
    ModalFileDetail,
    ModalViewFile,
    Pagination
  },
  props: {
    pageIndex: ''
  },
  data () {
    return {
      parameterID: 0,
      isSearch: false
    }
  },
  methods: {
    showNoData () {
      return this.folders.length === 0 && !this.loading
    },
    haveFolder () {
      return this.folders.length > 0
    },
    folderIsSearch () {
      return this.$route.params.id !== 'search'
    },
    scroll () {
      const ul = document.getElementById('data-files')
      const top = `${ul.scrollTop}px`
      const loading = document.getElementsByClassName('el-loading-mask')
      if (loading[0]) {
        loading[0].style.top = top
      }
    },
    isFileLike (mediaTypeId, likeAction) {
      return likeAction && mediaTypeId !== MEDIA_TYPE.FOLDER_ROLE_ID
    },
    changePage (pageIndex) {
      this.$emit('changePageIndex', pageIndex)
    },
    isNotFileLike (mediaTypeId, likeAction) {
      return !likeAction && mediaTypeId !== MEDIA_TYPE.FOLDER_ROLE_ID
    },
    isFolder (mediaTypeId) {
      return mediaTypeId === MEDIA_TYPE.FOLDER_ROLE_ID
    },
    openFolder (id, mediaType) {
      if (mediaType === MEDIA_TYPE.FOLDER_ROLE_ID) {
        this.$router.push({
          path: `/employee/items/${id}`,
          query: {tab: 'grid'}
        })
      } else {
        this.$store.dispatch('employeeFolder/getDetailFile', {id})
        this.$store.dispatch('employeeFolder/activeFile', {id: id, action_type: ACTION.ACTION_TYPE_LOG_READ})
        this.$root.$emit('bv::show::modal', 'modalViewFile', '#modalViewFile')
      }
    },
    showModalDetail (id, mediaId) {
      if (mediaId === MEDIA_TYPE.FOLDER_ROLE_ID) {
        this.$root.$emit('bv::show::modal', 'modalFolderDetail', '#modalFolderDetail')
        this.$store.dispatch('employeeFolder/detailFolder', {id})
      } else {
        this.$store.dispatch('employeeFolder/getDetailFile', {id})
        this.$root.$emit('bv::show::modal', 'modalFileDetail', '#modalFileDetail')
      }
    },
    isFile (mediaTypeId) {
      return mediaTypeId !== MEDIA_TYPE.FOLDER_ROLE_ID
    },
    isImage (mediaTypeId) {
      return mediaTypeId === MEDIA_TYPE.IMAGE_ROLE_ID
    },
    isVideo (mediaTypeId) {
      return mediaTypeId === MEDIA_TYPE.VIDEO_ROLE_ID
    },
    likeFile (id, likeAction) {
      if (likeAction) {
        this.$store.dispatch('employeeFolder/activeFile', {id: id, page_index: 1, folder_parent_id: this.$route.params.id, action_type: ACTION.ACTION_TYPE_LOG_LIKE_REMOVED})
      } else {
        this.$store.dispatch('employeeFolder/activeFile', {id: id, page_index: 1, folder_parent_id: this.$route.params.id, action_type: ACTION.ACTION_TYPE_LOG_LIKED})
      }
    },
    isVideoAndImage (mediaTypeId) {
      return mediaTypeId === MEDIA_TYPE.IMAGE_ROLE_ID || mediaTypeId === MEDIA_TYPE.VIDEO_ROLE_ID
    }
  },
  created () {
    this.parameterID = this.$route.params.id
    if (this.parameterID === 'search') {
      this.isSearch = true
    }
  },
  watch: {
    $route (newVal, oldVal) {
      if (Object.keys(newVal.query).length === 0) {
        this.parameterID = 0
        this.isSearch = false
      } else {
        this.isSearch = true
      }
    }
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  computed: {
    ...mapState({
      folders: state => state.employeeFolder.folders,
      metadata: state => state.employeeFolder.metadata,
      loading: state => state.employeeFolder.loading,
      totalPages: state => state.employeeFolder.metadata.total_pages
    })
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/stylesheet/mypage/detail_mypage.scss";
@import "@/assets/stylesheet/auth/listfile.scss";
</style>



// WEBPACK FOOTER //
// src/components/Employee/FolderManagerment/GridFiles.vue